// extracted by mini-css-extract-plugin
export default {"container":"NextArrow_container__3Ve9M","priority":"NextArrow_priority__qzcuC"};